import Bugsnag from "@bugsnag/js";
import React from "react";
import { useRouteError } from "react-router-dom";
import { errorLog } from "../utils/logger";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();
  const error: any = useRouteError();
  errorLog(error as Error);
  Bugsnag.notify(error);

  return (
    <div className="h-screen flex flex-col items-center justify-center text-white text-lg">
      <h1 className="text-xl">{t("system.not_found")}</h1>
      <a className="is-text-white mt-4" href="/">
        {t("generic.try")} app.dockethealth.com?
      </a>
      <img className="rounded-box" src="/assets/images/error.png" />
    </div>
  );
};
